<template>
  <li>
    <router-link :to="url">
      <i class="material-icons icon">{{ icon }}</i>
      <span>{{ label }}</span>
    </router-link>
  </li>
</template>

<script>
export default {
  props: {
    url: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: true
    }
  }
};
</script>
